import {z} from 'zod';

export const reportFilterOptionsResponseSchema = z.object({
  variants: z.array(z.string()),
  branches: z.array(z.string()),
  orderTypes: z.array(z.string()),
  states: z.array(z.string()),
});

export type ReportFilterOptions = z.infer<typeof reportFilterOptionsResponseSchema>;
